import {Injectable, signal, computed} from "@angular/core"
import {Mattress} from "@cm/mattress-nodes"

@Injectable()
export class MattressInspectorService {
    private readonly $mattressNode_ = signal<Mattress | undefined>(undefined, {})
    readonly $mattressNode = computed(() => this.$mattressNode_())
    setMattressNode(mattress: Mattress | undefined) {
        this.$mattressNode_.set(mattress)
    }

    readonly $mattressParameters = computed(
        () => {
            this.$triggerRecompute()
            return this.$mattressNode_()?.parameters
        },
        {equal: () => false},
    )

    private readonly $triggerRecompute = signal(0)
    onMattressParametersUpdated() {
        this.$triggerRecompute.update((x) => x + 1)
    }
}
